import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import useRDCOptions from 'features/rdc/hooks/useRDCOptions';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

const CheckDepositAgreementsScreen = () => {
  const router = useRouter();
  const { agreement, fetching, error } = useRDCOptions('cache-first');
  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      {agreement?.resource?.pdfDocument?.url ? (
        <PdfViewer url={agreement.resource.pdfDocument.url} />
      ) : null}
      <ScreenTransitionOverlay
        isLoading={fetching}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={
          error ? (
            <ErrorScreen
              screenType={ErrorScreenType.Error}
              messageHeadline={defaultTitle}
              messageBody={defaultMessage}
              primaryButton={{
                title: cancelButtonTitle,
                onPress: () => router.back(),
              }}
            />
          ) : null
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default CheckDepositAgreementsScreen;
